import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e9cc26c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center" }
const _hoisted_2 = ["type", "disabled", "onKeydown", "onKeyup", "data-bs-dismiss"]
const _hoisted_3 = {
  key: 1,
  class: "fas fa-search",
  "data-test": "button_icon"
}

import { ref } from 'vue'
import ButtonLoading from '@/components/common/button/ButtonLoading.vue'
import * as log from '@/model/util/log/Logger'
import { BUTTON_INPUTMODE, toButtonType } from './buttonType'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
  // type属性
  type: {
    type: String,
    default: BUTTON_INPUTMODE.BUTTON,
  },
  // ローディング表示有無
  loading: {
    type: Boolean,
    default: false,
  },
  // 非活性有無
  isDisabled: {
    type: Boolean,
    default: false,
  },
  // ボタン表示名
  label: {
    type: String,
    default: '',
  },
  // 追加スタイル
  styles: {
    type: String,
    default: undefined,
  },
  // ボタン表示名がアイコンか
  icon: {
    type: Boolean,
    default: false,
  },
  // モーダルのクローズボタンか
  closeEvent: {
    type: Boolean,
    default: false,
  },
},
  emits: ["button-click"],
  setup(__props, { emit }: { emit: ({
  (e: 'button-click'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

log.trace(`BaseButton setup start.`)
// プロパティ定義


// enterボタン開始有無
const isEnterStart = ref(false)

// モーダルクローズボタンのクラス名を取得する
const closeClass = () => (props.closeEvent ? 'modal' : undefined)

// Emit定義

// class属性付与
const classval = () => {
  // stylesの設定でclassを上書きする
  // 親コンポーネントからの追加指定をできないようにする
  const def = props.icon ? 'btn mxa-button-search' : 'btn mxa-button-base px-0'
  if (props.styles === undefined) {
    return def
  }
  return `${props.styles} ${def}`
}

/**
 * buttonTypeの取得
 */
const buttonType = toButtonType(props.type)

/**
 * クリックイベント
 */
const onClick = () => {
  log.trace(`BaseButton onClick.`)
  // enterのkeydownの状態は何もしない。keyupされるまで待つ
  if (isEnterStart.value) {
    log.debug(`BaseButton keydown exe.`)
    return
  }
  // keydown状態でない場合はemitする(クリック or keyup時)
  log.debug(`BaseButton click emit.`)
  emit('button-click')
}

/**
 * enter押下イベント
 */
const onKeydown = () => {
  log.trace(`BaseButton onKeydown.`)
  isEnterStart.value = true
}

/**
 * enter終了イベント
 */
const onKeyup = () => {
  log.trace(`BaseButton onKeydown.`)
  isEnterStart.value = false
  onClick()
}

log.trace(`BaseButton setup end.`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: _unref(buttonType),
      class: _normalizeClass(classval()),
      disabled: props.isDisabled,
      onKeydown: _withKeys(onKeydown, ["enter"]),
      onKeyup: _withKeys(onKeyup, ["enter"]),
      onClick: onClick,
      "data-bs-dismiss": closeClass()
    }, [
      (props.loading)
        ? (_openBlock(), _createBlock(ButtonLoading, {
            key: 0,
            icon: props.icon
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      (props.icon)
        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createTextVNode(_toDisplayString(props.label), 1)
          ], 64))
    ], 42, _hoisted_2)
  ]))
}
}

})